import ServiceDeskClient from "../../client";
import CognitoService from "../../../cognito";
import { IConversation, IUpdateConversationInput } from "./types";
import { GET_CONVERSATION, UPDATE_CONVERSATION, GET_MY_CONVERSATIONS } from "./graphql";

export const getMyConversations = async (mailboxId: string) => {
  let data: any | undefined;
  try {
    const token = await CognitoService.getToken();
    data = (
      await ServiceDeskClient.request({
        method: "post",
        headers: {
          Authorization: `Bearer ${token}`,
        },
        data: {
          query: GET_MY_CONVERSATIONS,
          variables: {
            input: { mailboxId },
          },
        },
      })
    )?.data;

    return {
      data: data.data.getMyConversations.data as IConversation[],
      success: true,
    };
  } catch (err) {
    console.error("getMyConversations", err);
    return {
      success: false,
    };
  }
};

export const getConversation = async (
  id: string,
  mailboxId: string,
  tenantId: string
) => {
  let data: any | undefined;
  try {
    const token = await CognitoService.getToken();
    data = (
      await ServiceDeskClient.request({
        method: "post",
        headers: {
          Authorization: `Bearer ${token}`,
        },
        data: {
          query: GET_CONVERSATION,
          variables: {
            input: { id, mailboxId, tenantId },
          },
        },
      })
    )?.data;

    return {
      data: data.data.getConversation,
      success: true,
    };
  } catch (err) {
    console.error("getConversation", err);
    return {
      success: false,
    };
  }
};

export const updateConversation = async (input: IUpdateConversationInput) => {
  let data: any | undefined;
  try {
    const token = await CognitoService.getToken();
    data = (
      await ServiceDeskClient.request({
        method: 'post',
        headers: {
          Authorization: `Bearer ${token}`,
        },
        data: {
          query: UPDATE_CONVERSATION,
          variables: {
            input,
          },
        },
      })
    )?.data;

    return {
      data: data.data.updateConversation,
      success: true,
    };
  } catch (err) {
    console.error('updateConversation', err);
    return {
      success: false,
    };
  }
};

export default {
  getMyConversations,
  getConversation,
  updateConversation
};
